<template>
    <div>
        <slot :manual-link="manualLink" :is-fallback="isFallback"></slot>
    </div>
</template>

<script>

export default {
    name: 'SupplyManual',
    computed: {
        // 화면 언어 파일이 없어 한국어 매뉴얼로 대체됐는지 (Faq 버튼에 '(한국어)' 표시)
        isFallback() {
            return this.$i18n.locale !== 'ko' && this.manualLink === this.ko_manual_url;
        },
        manualLink() {
            if (this.$i18n.locale === 'ko' && this.ko_manual_url) {
                return this.ko_manual_url;
            } else if (this.$i18n.locale === 'en' && this.en_manual_url) {
                return this.en_manual_url;
            }
            return this.ko_manual_url;
        },
        ko_manual_url() {
            return '/document/manual/2026 QESG 공급망 SAQ 평가 시스템 사용 매뉴얼(Ko).pdf';
        },
        en_manual_url() {
            return '/document/manual/2026 QESG Supply Chain SAQ Assessment System User Manual.pdf';
        },
    },
};
</script>
